<div class="input-group ps-1 time_picker">
    <input class="form-control f-12" type="time" placeholder="" aria-label="time">
</div>
